/**
 * UpgradeModalContext — Global provider that intercepts axios 403 PLAN_LIMIT_REACHED
 * and renders a single UpgradeModal anywhere in the app.
 */
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../services/api';
import UpgradeModal from '../components/UpgradeModal';

const UpgradeModalContext = createContext({ trigger: () => {} });

export const useUpgradeModal = () => useContext(UpgradeModalContext);

export const UpgradeModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(null);

  const trigger = useCallback((r) => {
    setReason(r || {});
    setOpen(true);
  }, []);

  const close = useCallback(() => setOpen(false), []);

  // Axios response interceptor: detect quota errors globally
  useEffect(() => {
    const interceptorId = api.interceptors.response.use(
      (response) => response,
      (error) => {
        const detail = error?.response?.data?.detail;
        if (
          error?.response?.status === 403 &&
          detail &&
          typeof detail === 'object' &&
          (detail.code === 'PLAN_LIMIT_REACHED' ||
            detail.code === 'COPILOT_QUOTA_EXCEEDED' ||
            detail.code === 'TRIAL_LIMIT_REACHED')
        ) {
          trigger(detail);
        }
        return Promise.reject(error);
      }
    );
    return () => api.interceptors.response.eject(interceptorId);
  }, [trigger]);

  return (
    <UpgradeModalContext.Provider value={{ trigger }}>
      {children}
      <UpgradeModal open={open} reason={reason} onClose={close} />
    </UpgradeModalContext.Provider>
  );
};
